import { FC, FunctionComponent, useEffect, useState } from "react"
import { v4 as uuidv4 } from 'uuid'
import { DictionaryInput } from "./dictionaryInput"

import { ContractorSelectorModal } from "../../Business/Dictionaries/Contractor"
import { GoodsSelectorModal } from "../../Business/Dictionaries/Goods"
import { PricingModelSelectorModal } from "../../Business/Dictionaries/PricingModel"
import { StoreSelectorModal } from "../../Business/Dictionaries/Store"
import { LotsSelectorModal } from "../../Business/Accounting/Lots"
import { ProducerSelectorModal } from "../../Business/Dictionaries/Producer"
import CashRegisterSelectorModal from "../../Business/Service/CashRegisters/CashRegisterSelectorModal"

import useGridFilter from "../../system/hooks/useGridFilter"
import { useAppContext } from "../../system/providers/appContextProvider"
import { BaseDirRequest } from "../../libs/core-api-requests/dirs/baseDirRequest"
import renderGlobalAlert from "../../system/hooks/useGlobalAlert"
import { IEntitySimpleDTO } from "../../libs/coreapi-dto/@types/common"
import styles from "./dictionaryInput.module.scss"
import classNames from "classnames"
import GridMultipleSelectorInputV2 from "./GridMultipleSelectorInputV2"
import { DefaultGrid } from "../grids/default/defaultGrid"
import { GoodsGroupAllSelectorModal } from "../../Business/Dictionaries/GoodsGroup/GoodsGroupAllSelectorModal"
import _ from 'underscore';
import CashSessionSelectorModal from "../../Business/Accounting/CashSession/Components/CashSessionSelectorModal"
import { GoodsClassifierSelectorModal } from "../../Business/Dictionaries/GoodsClassifier/components/GoodsClassifierSelectorModal"
import { LabelDesignerTemplateSelectorModal } from "../../Business/Service/LabelDesignerTemplate/LabelDesignerTemplateSelectorModal"
import { SubstanceSelectorModal } from "../../Business/Dictionaries/Substance"
import TaskProgramFormSelectorModal from "../../Business/Dictionaries/TaskProgram/TaskProgramFormSelectorModal"
import GosContractFundingSourceMultiSelectorModal from "../../Business/Dictionaries/GosContractFundingSource/selector/GosContractFundingSourceMultiSelectorModal"
import { GoodsGroupByGoodSelectorModal } from "../../Business/Dictionaries/GoodsGroup/GoodsGroupByGoodSelectorModal"
import { Button } from "../buttons/button"
import UserLocalSelectorModal from "../../Business/Service/UserLocal/components/selectorModal/UserLocalSelectorModal"
import { useTabsContext } from "../../system/providers/tabsProvider"

interface IComp {
    selector?: FunctionComponent<IGridSelectorModalProps>
    promise?: Promise<any>
}

const PluginGridSelectorInput: FC<IPluginGridSelectorInputProps> = (props) => {
    const tabsContext = useTabsContext()
    const loadInitialSelectedData = tabsContext.currentTab?.title !== 'Параметры отчёта:Отчет о начислении бонусов провизорам'
    const [visible, setVisible] = useState<boolean>(false)
    const [searchQuery, setSearchQuery] = useState<string>(loadInitialSelectedData ? props.displayNames[0] ?? '' : '')
    const [gridFilter, dispatchGridFilter] = useGridFilter()
    const [form, setForm] = useState(<></>)
    const appCtx = useAppContext()
    const [pluginValue, setPluginValue] = useState<Array<IEntitySimpleDTO>>(new Array<IEntitySimpleDTO>())
    const [data, setData] = useState<IEntitySimpleDTO[]>(loadInitialSelectedData ? props.selectedIds.map((idGlobal, index) => ({
        idGlobal,
        displayName: props.displayNames[index] ?? idGlobal
    })) : [])
    const [selectedItems, setSelectedItems] = useState<IGridRow[]>([]);    
    const returnComponent = (ComponentName) => {
        return <ComponentName
            masterIdGlobal={`dictionaryInput${ComponentName}-${uuidv4()}`}
            gridFilter={props.gridFilter ?? gridFilter}
            selectedEntity={pluginValue}
            multipleSelect={props.multipleSelect}
            ok={(e) => {
                setVisible(false)
                if (props.multipleSelect != undefined && !props.multipleSelect)
                    setSearchQuery(e.displayName ?? '')//ToDo siv не понять, что здесь делать, когда много значений
                pluginValue.length = 0
                if (Array.isArray(e))
                    pluginValue.push(...e)
                else
                    pluginValue.push(e)
                props.onSelect?.(pluginValue)
                reloadArray()
            }}
            cancel={() => {
                setVisible(false)
            }}
        />
    }

    function reloadArray() {
        let arr: Array<IEntitySimpleDTO> = pluginValue
        setPluginValue([...arr])
    }

    function getPluginView(): IComp {
        let request: Promise<any> | undefined;
        let selector: FunctionComponent<IGridSelectorModalProps>

        switch (props.mnemocode) { //Todo siv вынести в функцию, чтобы убрать возможность не вписать все енумы в свитче 
            case 'goods_plugin':
                if (props.selectedIds.length > 0)
                    request = appCtx.coreApiService?.goodsRequest
                selector = GoodsSelectorModal
                break;
            case 'contractor_plugin':
                if (props.selectedIds.length > 0)
                    request = appCtx.coreApiService?.contractorRequest
                selector = ContractorSelectorModal
                break;
            case 'store_plugin':
                if (props.selectedIds.length > 0)
                    request = appCtx.coreApiService?.storeRequest
                selector = StoreSelectorModal
                break;
            case 'pricing_model_plugin':
                if (props.selectedIds.length > 0)
                    request = appCtx.coreApiService?.pricingModelRequest
                selector = PricingModelSelectorModal
                break;
            case 'lot_plugin':
                if (props.selectedIds.length > 0)
                    request = appCtx.coreApiService?.lotRequest
                selector = LotsSelectorModal
                break;
            case 'producer_plugin':
                if (props.selectedIds.length > 0)
                    request = appCtx.coreApiService?.producerRequest
                selector = ProducerSelectorModal
                break;
            case 'cash_registers_plugin':
                if (props.selectedIds.length > 0)
                    request = appCtx.coreApiService?.cashRegisterRequest
                selector = CashRegisterSelectorModal
                break;
            case 'users_plugin':
                if (props.selectedIds.length > 0)
                    request = appCtx.coreApiService?.userRequest
                selector = UserLocalSelectorModal
                break;
            case 'goods_group_plugin':
                if (props.selectedIds.length > 0)
                    request = appCtx.coreApiService?.goodsGroupRequest
                selector = GoodsGroupAllSelectorModal
                break;
            case 'goods_groupByGood_plugin':
                if (props.selectedIds.length > 0)
                    request = appCtx.coreApiService?.goodsGroupRequest
                selector = GoodsGroupByGoodSelectorModal
                break;
            case 'cash_session_plugin':
                if (props.selectedIds.length > 0) {
                    request = appCtx.coreApiService?.cashSessionRequest
                }
                selector = CashSessionSelectorModal
                break;
            case 'goods_classifier_plugin':
                if (props.selectedIds.length > 0) {
                    request = appCtx.coreApiService?.goodsClassifierRequest
                }
                selector = GoodsClassifierSelectorModal
                break;
            case 'label_designer_template_plugin':
                if (props.selectedIds.length > 0) {
                    request = appCtx.coreApiService?.labelDesignerTemplateRequest
                }
                selector = LabelDesignerTemplateSelectorModal
                break;
            case 'substance_plugin':
                if (props.selectedIds.length > 0) {
                    request = appCtx.coreApiService?.substanceRequest
                }
                selector = SubstanceSelectorModal
                break;
            case 'task_program_plugin':
                if (props.selectedIds.length > 0) {
                    request = appCtx.coreApiService?.taskProgramRequest
                }
                selector = TaskProgramFormSelectorModal
                break;
            case 'gos_contract_funding_source_plugin':
                if (props.selectedIds.length > 0) {
                    request = appCtx.coreApiService?.gosContractFundingSourceRequest
                }
                selector = GosContractFundingSourceMultiSelectorModal
                break;
            default:
                return { promise: request, selector: undefined } as unknown as IComp //ToDo siv времянка
        }

        return { promise: request, selector: selector } as unknown as IComp
    }

    async function getSelectorModal() {
        const view: IComp = getPluginView()
        let selector = view.selector

        if (!loadInitialSelectedData) {
            setForm(returnComponent(selector))
            return
        }

        const promises = new Array<Promise<any>>()
        if (view.promise != undefined)
            promises.push(view.promise)

        let loaded: boolean
        if (promises.length > 0) {
            loaded = false
            await Promise.all(promises).then(function (data) {
                if (data != undefined) {
                    pluginValue.length = 0
                    const request: BaseDirRequest<any, any> = data[0] as unknown as BaseDirRequest<any, any>
                    let count: number = 0
                    const length: number = props.selectedIds.length
                    let arr: Array<IEntitySimpleDTO> = new Array<IEntitySimpleDTO>(length)
                    props.selectedIds.forEach((item, index) => {
                        request.getById(item as string, e => {
                            if (e.respType === "isCompleted") {
                                const entity = { idGlobal: item, displayName: e.data.name } as unknown as IEntitySimpleDTO
                                arr[index] = entity
                                if (!props.multipleSelect) {
                                    setSearchQuery(entity.displayName ?? '')
                                }
                            }
                            count++
                            if (count == length) {
                                const loadedItems = arr.filter(Boolean)
                                pluginValue.push(...loadedItems)
                                if (props.multipleSelect) {
                                    setData(loadedItems)
                                }
                                reloadArray()
                                loaded = true
                            }
                        })
                    })
                } else
                    loaded = true
            }).catch(ex => {
                renderGlobalAlert({
                    variant: ex.message.type,
                    title: ex.message.text,
                    statusCode: ex.message.statusCode ?? 500
                })
                loaded = true
            })
        }
        else
            loaded = true

        await until(_ => loaded == true)
        setForm(returnComponent(selector))
    }

    function until(conditionFunction) {
        const poll = resolve => {
            if (conditionFunction())
                resolve()
            else
                setTimeout(_ => poll(resolve), 400)
        }
        return new Promise(poll);
    }

    useEffect(() => {
        getSelectorModal()
    }, [])

    function clear() {
        props.onSelect?.(pluginValue)
        setSearchQuery('')
        dispatchGridFilter({ type: 'deleteColumnFilter', payload: props.defaultPropertyName ?? 'name' })
        props.onClear?.()
    }

    function more(value) {
        props.onFocus?.()
        setVisible(true)
        value && dispatchGridFilter({ type: 'addColumnFilter', payload: { name: props.defaultPropertyName ?? 'name', operator: 'Like', value: `%${value}%` } })
        setSearchQuery(value ?? '')
    }

    function getClassNames() {
        const variant = props.disabled === true ? "disabled" : props.variant

        if (props.inline) {
            switch (variant) {
                case undefined:
                case "normal": return styles.dictNormalInline
                case "red": return styles.dictRedInline
                case "green": return styles.dictGreenInline
                case "disabled": return styles.dictDisabledInline
            }
        } else {
            switch (variant) {
                case undefined:
                case "normal": return styles.dictNormal
                case "red": return styles.dictRed
                case "green": return styles.dictGreen
                case "disabled": return styles.dictDisabled
            }
        }
    }

    const handleDeleteSelected = () => {
        if (selectedItems.length === 0) return;
        
        const newData = data.filter(item => 
            !selectedItems.some(selected => selected.idGlobal === item.idGlobal)
        );
        
        setData(newData);
        setSelectedItems([]);
        props.onSelect?.(newData);
    };

    const handleGridSelect = (rows: IGridRow[]) => {
        setSelectedItems(rows);
    };
   
    return <>
        {props.multipleSelect === false &&
            <DictionaryInput
                disabledInput={props.disabledInput}
                inputId={props.id}
                label={props.label}
                placeholder={props.placeholder ?? '-- Не выбрано --'}
                className={props.className}
                labelClassName={props.labelClassName}
                inline={props.inline}
                disabled={props.disabled}
                value={searchQuery}
                error={props.error}
                onMoreClick={(value) => {
                    more(value)
                }}
                onClearClick={() => {
                    clear()
                }}
                onFocus={() => props.onFocus?.()}
            />
        }
        {props.multipleSelect === true &&
            <div className={props.error ? classNames(props.className, getClassNames(), styles.dictRed) : classNames(props.className, getClassNames())}>
                <GridMultipleSelectorInputV2
                    disabledInput={props.disabledInput}
                    label={props.label}
                    placeholder={props.placeholder ?? '-- Не выбрано --'}
                    className={props.className}
                    labelClassName={props.labelClassName}
                    inline={props.inline}
                    disabled={props.disabled}
                    value={searchQuery}
                    onClear={() => {
                        setData([])
                        setSelectedItems([])
                        props.onSelect?.([])
                    }}
                    error={props.error}
                    selectorModalJsx={getPluginView().selector}
                    onFocus={() => props.onFocus?.()}
                    onSelect={(value) => {
                        setData(value)
                        props.onSelect?.(value)
                    }}
                    activateGroupProcessing={true}
                    isSearchForMultyselect={true}
                    dataFromPluginGridSelectorInput={data}
                />
                <DefaultGrid
                    gridId={uuidv4()}
                    data={data}
                    multipleSelect
                    selectedItems={selectedItems}
                    filter={gridFilter}
                    totalCount={data.length}
                    showQuantity
                    hideSettingsAndExportButton
                    plugin={props.gridPlugin ?? {} as IPluginSettings}
                    selectedItem={undefined}
                    onSelect={(row) => { }}
                    onMultipleSelect={handleGridSelect}
                    onSort={(i) => { dispatchGridFilter({ type: "sort", payload: i.propertyName }) }}
                    onFilterDelete={(i) => { dispatchGridFilter({ type: "deleteColumnFilter", payload: i.propertyName }) }}
                    onPageNumberChange={(n) => { dispatchGridFilter({ type: "changePageNumber", payload: { pageNumber: n } }) }}
                    onNumberPerPageChange={(n) => { dispatchGridFilter({ type: "changeNumberPerPage", payload: { numberPerPage: n } }) }}
                    hiddenPagination={undefined}
                />
                <div style={{width: 150}}>
                    <Button                
                        variant="outprimary"
                        onClick={handleDeleteSelected}
                        disabled={selectedItems.length === 0}
                        style={{ marginTop: '10px' }}
                    >
                        Удалить
                    </Button>
                </div>
            </div>
        }
        {
            visible && form
        }
    </>
}
export default PluginGridSelectorInput
